import {Injectable} from '@angular/core';
import {forkJoin, mergeMap, Observable, of, Subject} from "rxjs";
import {filter, tap} from "rxjs/operators";
import {FileRestService} from "../../api/services/file.rest.service";
import {DocumentApiModel} from "../../api/models/document.api-model";
import {DocumentRestService} from "../../api/services/document.rest.service";
import {ProjectApiModel} from "../../api/models/project.api-model";

@Injectable({
  providedIn: 'root',
})
export class DocumentUploadService {

  public files: File[] = [];
  public newFiles: File[] = [];
  constructor(
    private readonly documentRS: DocumentRestService,
    private readonly frs: FileRestService,
  ) {}

  uploadDocument(documentsAMs: DocumentApiModel[]): Observable<{ documents$: Observable<DocumentApiModel[]>; progress$: Observable<number> }> {
    const progress$ = new Subject<number>();
    const uploadRequests: Observable<DocumentApiModel>[] = [];
    const totalFiles = documentsAMs.length;

    const individualProgress: number[] = Array(totalFiles).fill(0);

    documentsAMs.forEach((documentAM, index) => {
      let uploadRequest: Observable<number | DocumentApiModel>;

      if (!documentAM['@id']) {
        uploadRequest = this.documentRS.uploadItemWithProgress(documentAM.type, documentAM.file, documentAM.description);
      } else {
        uploadRequest = this.documentRS.put(documentAM);
      }

      const filteredRequest: Observable<DocumentApiModel> = uploadRequest.pipe(
        tap((progressOrModel) => {
          if (typeof progressOrModel === 'number') {
            individualProgress[index] = progressOrModel;
            const totalProgress = individualProgress.reduce((sum, curr) => sum + curr, 0) / totalFiles;
            progress$.next(totalProgress);
          }
        }),
        filter((progressOrModel) => typeof progressOrModel !== 'number') // Filtruj, aby pozostały tylko modele
      ) as Observable<DocumentApiModel>;

      uploadRequests.push(filteredRequest);
    });

    if (!uploadRequests.length) {
      progress$.next(100); // Jeśli brak plików, zakończ progress
      progress$.complete();
      return of({ documents$: of([]), progress$: of(100) });
    }

    const documents$ = forkJoin(uploadRequests).pipe(
      tap(() => {
        progress$.next(100); // Postęp końcowy
        progress$.complete();
      })
    );

    return of({ documents$: documents$, progress$: progress$.asObservable() });
  }

  public deleteDocumentForProject(documentId: string, projectAM: ProjectApiModel): Observable<object> {
    return this.documentRS.delete(documentId);
  }

  public convertUrlToFile(fileUrls: string[]): Observable<File[]> {
    console.log(fileUrls);
    const requests: Observable<File>[] = [];
    for (const url of fileUrls) {
      // arr.push(new File([await (await fetch(url)).blob()], url, {type: 'image/jpeg'}));
      requests.push(this.frs.getFile(url).pipe(tap(file => {
        if (!this.files.find(f => f.name == file.name)) {
          this.files.push(file);
        }
      })));
    }

    if (!requests.length) {
      this.files = [...this.newFiles];
      return of(this.files);
    }

    return forkJoin(requests);
  }
}


